import React, { useEffect, useState } from 'react';
import { Menu, X, Scissors, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { shopInfo } from '../mock';

const nav = [
  { label: 'Le salon', href: '#salon' },
  { label: 'Prestations', href: '#services' },
  { label: 'Galerie', href: '#gallery' },
  { label: 'Horaires', href: '#hours' },
  { label: 'Avis', href: '#reviews' },
  { label: 'Contact', href: '#contact' },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#0a0a0a]/85 backdrop-blur-xl border-b border-[#c9a961]/15 py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 group">
          <div className="w-9 h-9 rounded-full border border-[#c9a961]/60 flex items-center justify-center group-hover:border-[#c9a961] transition-colors">
            <Scissors className="w-4 h-4 text-[#c9a961]" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-xl text-[#f5efe4]">JR Barber</div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#c9a961]">Toulouse</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="link-gold text-sm font-medium text-[#e6ddc9] hover:text-[#c9a961]"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={`tel:${shopInfo.phone.replace(/\s/g, '')}`}
            className="flex items-center gap-2 text-sm text-[#e6ddc9] hover:text-[#c9a961] transition-colors"
          >
            <Phone className="w-4 h-4" />
            {shopInfo.phone}
          </a>
          <a href={shopInfo.planityUrl} target="_blank" rel="noreferrer">
            <Button className="bg-[#c9a961] hover:bg-[#d9b972] text-[#0a0a0a] font-semibold px-5 rounded-none border border-[#c9a961] hover:border-[#d9b972]">
              Réserver
            </Button>
          </a>
        </div>

        <button
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden text-[#f5efe4] p-2"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          open ? 'max-h-[500px] mt-4' : 'max-h-0'
        }`}
      >
        <div className="px-6 pb-6 flex flex-col gap-4 bg-[#0a0a0a]/95 backdrop-blur-xl">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              onClick={() => setOpen(false)}
              className="text-[#e6ddc9] hover:text-[#c9a961] text-lg font-medium py-2 border-b border-[#c9a961]/10"
            >
              {n.label}
            </a>
          ))}
          <a
            href={shopInfo.planityUrl}
            target="_blank"
            rel="noreferrer"
            onClick={() => setOpen(false)}
          >
            <Button className="w-full bg-[#c9a961] hover:bg-[#d9b972] text-[#0a0a0a] font-semibold rounded-none">
              Réserver un créneau
            </Button>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
